/*
 * サブシステム名：マスタ管理
 * 機能名：自社銀行口座登録
 */
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdIconButton = () => import('@/components/DdIconButton.vue')

export default {
  name: 'MstJishaGinkoKozaEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false
  }),
  components: {
    DdTransparentButton,
    DdEditCommonBar,
    DdSubHeader,
    DdTextBox,
    DdRadioButton,
    DdDropDown,
    DdNumericBox,
    DdIconButton
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'users/helpUseFlg'
    }),
    isDeleteDisable () {
      return this.id === 0
    },
    filteredkozaSbt () {
      const listData = this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF070'
      }).map(function (elem) {
        elem.value = elem.code.trim()
        elem.text = elem.codeNm.trim()
        return elem
      })
      return listData
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/MstJishaGinkoKoza/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload

            console.log('recived data', this.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msyskubun'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              hyojiOrder: '9999',
              kozaSbt: '1',

              kinyuKikannm: '',
              kinyuKikanShitenNm: '',
              kinyuKikanCd: '',
              kinyuKikanShitenCd: '',
              kozaNo: '',
              kozaMeigiNm: '',
              nyukinDataKozaNmKana: '',
              shukkinDataKozaNmKana: '',
              seikyushoKozaNmHyojiNaiyo: '',
              shiharaiyoKozaNmHyojiNaiyo: '',
              gaibuRenkeiyoText: '',
              ginkoKozaJohoBiko: ''
            }
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstJishaGinkoKoza/Delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // this.id = id
            this.transition(1, { id: self.id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/MstJishaGinkoKoza/Create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MstJishaGinkoKoza/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    },
    onSeikyushoKozaNmHyojiNaiyoCopyClick: function () {
      this.rec.seikyushoKozaNmHyojiNaiyo =
      (this.rec.kinyuKikanCd ? this.rec.kinyuKikanCd + ' ' : '') +
      (this.rec.kinyuKikanNm ? this.rec.kinyuKikanNm + ' ' : '') +
      (this.rec.kinyuKikanShitenCd ? this.rec.kinyuKikanShitenCd + ' ' : '') +
      (this.rec.kinyuKikanShitenNm ? this.rec.kinyuKikanShitenNm + ' ' : '') +
      (this.getKozaSyubetsuName(this.rec.kozaSbt)) +
      (this.rec.kozaNo ? this.rec.kozaNo + ' ' : '') +
      (this.rec.kozaMeigiNm ? this.rec.kozaMeigiNm : '')
    },
    onShiharaiyoKozaNmHyojiNaiyoCopyClick: function () {
      this.rec.shiharaiyoKozaNmHyojiNaiyo =
      (this.rec.kinyuKikanCd ? this.rec.kinyuKikanCd + ' ' : '') +
      (this.rec.kinyuKikanNm ? this.rec.kinyuKikanNm + ' ' : '') +
      (this.rec.kinyuKikanShitenCd ? this.rec.kinyuKikanShitenCd + ' ' : '') +
      (this.rec.kinyuKikanShitenNm ? this.rec.kinyuKikanShitenNm + ' ' : '') +
      (this.getKozaSyubetsuName(this.rec.kozaSbt)) +
      (this.rec.kozaNo ? this.rec.kozaNo + ' ' : '') +
      (this.rec.kozaMeigiNm ? this.rec.kozaMeigiNm : '')
    },
    getKozaSyubetsuName: function (code) {
      const listData = this.filteredkozaSbt.filter(function (elem) {
        return elem.value === code
      })
      if (listData.length > 0) {
        return (listData[0].text + ' ')
      }
      return ''
    }
  }
}
